import { render, staticRenderFns } from "./ArticleImportance.vue?vue&type=template&id=3599dae6&scoped=true"
import script from "./ArticleImportance.vue?vue&type=script&lang=js"
export * from "./ArticleImportance.vue?vue&type=script&lang=js"
import style0 from "./ArticleImportance.vue?vue&type=style&index=0&id=3599dae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3599dae6",
  null
  
)

export default component.exports